import { EnergyOfferParametersGeneration } from './EnergyOfferParametersGeneration'
import * as Sentry from '@sentry/react'
import { saving, setErrors } from '@/containers/OrganizationsManagement/organizationsManagementSlice'

const SaveEnergyOffer = async (providerState, dispatch, url, headers, sendRequest, country, { onSuccess } = {}) => {
  dispatch(saving({ loading: true }))

  headers.body = EnergyOfferParametersGeneration(providerState.selectedOffer, providerState.selectedProvider.id, country)

  await sendRequest(url, headers, (json, status) => {
    if (status === 200) {
      dispatch(setErrors({}))
      onSuccess?.()
    }
    if (status === 422) {
      dispatch(setErrors(json.errors))
    }

    if (json.errors) {
      if (import.meta.env.PROD) {
        Sentry.captureException(new Error('Errors in SaveEnergyOffer'), { extra: { context: 'SaveEnergyOffer', errors: json.errors } })
      }
    }

    dispatch(saving({ loading: false }))
  })
}

export default SaveEnergyOffer
